import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { FlexProps } from "@portal/BaseComponents/Flex/type";
import { Popover } from "@portal/BaseComponents/PopOver/AntPopOver";
import { PopoverProps } from "@portal/BaseComponents/PopOver/type";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { Unpacked } from "@portal/types/utils";

export type TextObj = { value: string; id: string | number };
export interface TextWithPopoverProps {
  heading?: string;
  text: TextObj[];
  popOverContent?: PopoverProps["content"];
  overLayInnerStyles?: PopoverProps["overlayInnerStyle"];
  wrapperProps?: Omit<FlexProps, "children">;
  sortText?: boolean;
}

function TextWithPopoverColumn(props: TextWithPopoverProps) {
  const {
    heading,
    text,
    popOverContent,
    overLayInnerStyles,
    wrapperProps,
    sortText = true,
  } = props;
  const [first, ...Rest] = text;
  const restTypes = Rest.length;
  const mapPredicate = (text: Unpacked<TextWithPopoverProps["text"]>) => (
    <TypographyText key={text.id}>{text.value}</TypographyText>
  );

  const sortUserInfoPredicate = (
    typeA: Unpacked<TextWithPopoverProps["text"]>,
    typeB: Unpacked<TextWithPopoverProps["text"]>
  ) => {
    const nameA = typeA.value.toUpperCase();
    const nameB = typeB.value.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  };

  const defaultPopOverContent = (
    <Flex vertical align="start">
      <TypographyText strong>{heading}</TypographyText>
      {sortText
        ? [...text].sort(sortUserInfoPredicate).map(mapPredicate)
        : [...text].map(mapPredicate)}
    </Flex>
  );

  const content = popOverContent ? popOverContent : defaultPopOverContent;
  return (
    <Popover
      content={content}
      placement="bottom"
      arrow={false}
      open={restTypes > 0 ? undefined : false}
      overlayInnerStyle={overLayInnerStyles}
    >
      <Flex
        justify="flex-start"
        space="4"
        style={{ height: "100%" }}
        {...wrapperProps}
      >
        <TypographyText
          ellipsis={
            restTypes > 0 ? true : { tooltip: first ? first.value : null }
          }
          fs="14"
        >
          {first?.value}
        </TypographyText>
        {restTypes > 0 && (
          <TypographyText>{`+ ${restTypes} more`}</TypographyText>
        )}
      </Flex>
    </Popover>
  );
}

export { TextWithPopoverColumn };
